import {IBaseResourceItem} from 'models/resources';

export const getResourcesCollectionByIds = (
  contentItemIds: string[],
  collection: IBaseResourceItem[]
): IBaseResourceItem[] => collection.filter((item) => contentItemIds.indexOf(item.contentItemId) !== -1);
